import { Flame, Phone, Mail, Instagram, MapPin, Clock } from "lucide-react";
import {
  PHONE_DISPLAY,
  PHONE2_DISPLAY,
  PHONE_TEL,
  EMAIL,
  EMAIL_FINANCEIRO,
  COMPANY_NAME,
  CNPJ,
  INSTAGRAM_HANDLE,
  INSTAGRAM_URL,
  ADDRESS_LINES,
  HOURS,
  CITY,
  LOGO_WHITE,
} from "@/data/content";

const Footer = () => {
  return (
    <footer data-testid="footer" className="bg-[#0c1326] text-white pt-20 pb-8">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-5">
            <img src={LOGO_WHITE} alt="Bahia Gás" className="h-11 w-auto object-contain" />
          </div>
          <p className="text-white/55 leading-relaxed max-w-xs">
            Revenda autorizada Ultragaz em {CITY}. Mais de 33 anos de experiência em entrega de gás de cozinha e água
            mineral.
          </p>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-white/5 hover:bg-white/10 text-white/70 hover:text-white transition-colors mt-8"
          >
            <Instagram className="w-5 h-5" />
          </a>
        </div>

        <div>
          <h4 className="font-bold tracking-widest text-sm mb-6">CONTATO</h4>
          <ul className="space-y-4 text-white/65">
            <li className="flex items-start gap-3">
              <Phone className="w-5 h-5 text-[#a3e635] shrink-0 mt-0.5" />
              <a href={`tel:${PHONE_TEL}`} className="hover:text-white">
                {PHONE_DISPLAY}
                <br />
                {PHONE2_DISPLAY}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-[#a3e635] shrink-0" />
              <a href={`mailto:${EMAIL}`} className="hover:text-white break-all">{EMAIL}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-5 h-5 text-[#a3e635] shrink-0" />
              <a href={`mailto:${EMAIL_FINANCEIRO}`} className="hover:text-white break-all">{EMAIL_FINANCEIRO}</a>
            </li>
            <li className="flex items-center gap-3">
              <Instagram className="w-5 h-5 text-[#a3e635] shrink-0" />
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="hover:text-white">
                {INSTAGRAM_HANDLE}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold tracking-widest text-sm mb-6">ENDEREÇO</h4>
          <div className="flex items-start gap-3 text-white/65">
            <MapPin className="w-5 h-5 text-[#a3e635] shrink-0 mt-0.5" />
            <p className="leading-relaxed">
              {ADDRESS_LINES.map((l) => (
                <span key={l} className="block">{l}</span>
              ))}
            </p>
          </div>
        </div>

        <div>
          <h4 className="font-bold tracking-widest text-sm mb-6">HORÁRIOS</h4>
          <div className="flex items-start gap-3 text-white/65">
            <Clock className="w-5 h-5 text-[#a3e635] shrink-0 mt-0.5" />
            <p className="leading-relaxed">
              {HOURS.map((h) => (
                <span key={h} className="block">{h}</span>
              ))}
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 border-t border-white/10 mt-14 pt-6">
        <p data-testid="footer-company" className="text-white/50 text-sm text-center sm:text-left">
          {COMPANY_NAME} — CNPJ {CNPJ}
        </p>
        <div className="mt-3 flex flex-col sm:flex-row items-center justify-between gap-3 text-white/40 text-sm">
          <p>© {new Date().getFullYear()} Bahia Gás Ipatinga. Todos os direitos reservados.</p>
          <p className="flex items-center gap-2">
            <Flame className="w-4 h-4 text-[#a3e635]" /> Revenda Autorizada Ultragaz
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
